module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/218.d7847bc1.png";